import { unsafeCoerce } from 'fp-ts/lib/function';
import getRuntimeConfig from 'next/config';
import defaults from '../../../tools/config/defaultEnv.json';
import { asDynamic } from './Dynamic';

/**  Provides a view of the injected environment variables, combined with their default values.
 *
 * We can coerce this safely because the runtime config is derived from combining the environment variables
 * with the JSON file of defaults.
 *
 * @see /next.config.js
 */
export const runtimeConfig: typeof defaults = unsafeCoerce(
  asDynamic(getRuntimeConfig())?.publicRuntimeConfig ?? defaults,
);

export const env = runtimeConfig;
